module.exports = __webpack_public_path__ + "68aed551fa33de68db02a0ed246163ae.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-center/info-sharing-center-ja.html
// module id = 1047
// module chunks = 0